export enum APP_ROUTES {
  Login = '/',
  SignIn = '/email-signin',
  SignInEmail = '/email-signin',
  SignInCode = '/email-signin/code',
  SignInCheckEmail = '/email-signin/check_email',
  ErrorVPN = '/error-vpn',
  ErrorBanned = '/error-banned',
  UserInfo = '/user-info',
  UserInfoLite = '/user-info-lite',
  UserInfoLitePhone = '/user-info-lite-phone',
  PayWallBackupPayment = '/pay-wall-standalone',
  Checkout = '/checkout',
  TermsOfServiceGroup = '/terms',
  TermsOfServiceInc = '/terms-of-service',
  PrivacyPolicyGroup = '/privacy',
  PrivacyPolicyInc = '/privacy-policy',
  ContactsGroup = '/contact-us',
  ContactsInc = '/contacts',
  CookiePolicy = '/cookie-policy',
  CommunityGuidelines = '/community-guidelines',
  AmbassadorAgreement = '/ambassador-public-agreement',
  UnderMaintenance = '/under-maintenance',
  BuildInfo = '/build-info',
  Push = '/push',
  Home = '/app/profile',
  FAQ = '/app/faq',
  Map = '/app/map',
  Chats = '/app/chats',
  Chat = '/app/chat',
  People = '/app',
  LikedPeople = '/app/liked-people',
  Subscription = '/app/subscription',
  PhotoIssues = '/app/photo-issues',
  Verification = '/app/verification',
  LocationVerification = '/app/location-verification',
  Settings = '/app/settings',
  Account = '/app/account',
  DeleteAccount = '/app/account-delete',
  SocialMedia = '/app/social-media',
  EditProfile = '/app/edit-profile',
  EditInterests = '/app/edit-profile/interests',
  EditLanguages = '/app/edit-profile/languages',
  EditEthnicities = '/app/edit-profile/ethnicities',
  EditNationalities = '/app/edit-profile/nationalities',
  Translator = '/app/translator',
  TranslateChat = '/app/translate-chat',
  TranslationLanguage = '/app/translation-language',
  Report = '/app/report',
  UnconfirmedEmail = '/app/unconfirmed-email',
  PhotoRules = '/app/photo-rules',
  UnconfirmedPhone = '/app/unconfirmed-phone',
  ResumeSignup = '/resume-signup',
  SharedLink = '/shared-link',
  EmailConfirmation = '/email-confirmation',
  SignInContinue = '/sign-in-continue',
}
